import { useGetUserInfoQuery } from 'app/hooks/user-info';

export default function useUsername() {
  const { data: user } = useGetUserInfoQuery();

  const username =
    user?.first_name && user?.last_name
      ? `${user?.first_name} ${user?.last_name}`
      : user?.email;

  return username;
}
